export default "/images/vendor/@coreui/icons/svg/flag/cif-gw.svg?51fb45be65091b42d88d02068ff035d2";